
import makeStyles from '@mui/styles/makeStyles';

import ListViewEntryListItem from "./ListViewEntryListItem";
import { memo } from "react";

import "./ListViewEntryList.scss";
import RenderIfVisible from '../../Utils/RenderIfVisible';

const useStyles = makeStyles(theme => ({
    listItem: {
        borderTop: "1px solid",
        borderColor: theme.palette.secondary.dark,
    },
}));

export default memo(function ListViewEntryList ({ linkComponent, entriesData }) {

    const classes = useStyles();

    return (
        <>
            <ul className="ListViewEntryList">
                {entriesData.map((entryData) => (
                    <li id={`e${entryData.entry.id}`} className={`ListViewEntryList__item ${classes.listItem}`} key={`${entryData.entry.id}-${entryData.category?.id}`}>
                        <RenderIfVisible estimatedHeight="100px">
                            <ListViewEntryListItem 
                                entry={entryData.entry}
                                categoryId={entryData.category?.id}
                                categoryName={entryData.category?.title}
                                linkComponent={linkComponent}
                            />
                        </RenderIfVisible>
                    </li>
                ))}
            </ul>
        </>
    );
});